import { define, generateTestIdObject } from '../../utils';

const PAGE_NAME = 'qconfig-detail';

const ELEMENTS = define({
  STATUS_TAG: ['status', 'tag'],
  HEADER_MENU: ['header', 'menu'],
  ADD_SINGLE_MENU_ITEM: ['add-single', 'menu-item'],
  ADD_ITEM_SET_MENU_ITEM: ['add-item-set', 'menu-item'],
  REMOVE_CHAPTER_MENU_ITEM: ['remove-chapter', 'menu-item'],
});

export const QCONFIG_DETAIL_DATA_TEST_ID = generateTestIdObject(PAGE_NAME, ELEMENTS);
